import React, {Component} from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import TentangOpenData from "./tentang/TentangOpenData";

export class PagesTentangaOpenData extends Component{
    render(){
        return(
            <div>
                <HeaderOpenData />
                <TentangOpenData />
                <FooterOpenData />
            </div>
        )
    }
}

export default PagesTentangaOpenData;